/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  INGEST_FETCHING,
  INGEST_FETCHING_DONE,
  INGEST_FETCHING_ERROR,
  SET_INGEST,
  SET_INGEST_DONE,
  SET_INGEST_ERROR,
  INGEST_SET_CSV,
  INGEST_SET_QUERY,
  IngestActions
} from 'store/action/ingest';
import {ILineChartData} from 'interfaces/chartProps';
import {IPortalError} from 'utility/error-handler';

export interface IIngestState {
  ingest: ILineChartData[];
  isFetching: boolean;
  error: null | Error | IPortalError;
  csv: string;
  queryData: {start: Date; end: Date}[];
}

const initialState: IIngestState = {
  ingest: [],
  isFetching: false,
  error: null,
  csv: '',
  queryData: []
};
const ingest: Reducer<Readonly<IIngestState>, IngestActions> = (
  state: IIngestState = initialState,
  action: IngestActions
) => {
  switch (action.type) {
    case INGEST_FETCHING:
    case SET_INGEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case INGEST_FETCHING_DONE:
    case SET_INGEST_DONE: {
      return {
        ...state,
        isFetching: false,
        ingest: [...action.payload, ...state.ingest],
        error: null
      };
    }

    case INGEST_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case SET_INGEST_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case INGEST_SET_CSV: {
      return {
        ...state,
        csv: action.payload
      };
    }

    case INGEST_SET_QUERY: {
      return {
        ...state,
        queryData: [...state.queryData, action.payload],
        isFetching: false
      };
    }

    default: return state;
  }
};

export default ingest;